import { Comparable } from '../../record/entities/misc/comparable.interface';
import { Trackable } from '../../record/entities/misc/trackable.interface';

export interface QueryInfo {
    readonly Name: string;
    readonly Groups: string[];
}
export interface NewSavedQuery extends QueryInfo {
    readonly Query: string;
}

export interface SavedQueryContext {
    IsEditable: boolean;
    IsDeletable: boolean;
}

export interface ISavedQuery extends NewSavedQuery {
    readonly Id: string;
    readonly CreatedBy: string;
    readonly OrganisationId: string;
    readonly Context: SavedQueryContext;
}

export class SavedQuery implements ISavedQuery, Comparable, Trackable {
    readonly Id: string;
    readonly Name: string;
    readonly Groups: string[];
    readonly CreatedBy: string;
    readonly Query: string;
    readonly OrganisationId: string;
    readonly Context: SavedQueryContext;

    constructor(savedQuery: ISavedQuery) {
        this.Id = savedQuery.Id;
        this.Name = savedQuery.Name;
        this.Groups = savedQuery.Groups;
        this.CreatedBy = savedQuery.CreatedBy;
        this.Query = savedQuery.Query;
        this.OrganisationId = savedQuery.OrganisationId;
        this.Context = savedQuery.Context;
    }

    equals(other: any): boolean {
        if (!(other instanceof SavedQuery)) {
            return false;
        }
        return this.Id === other.Id;
    }

    trackBy(): string {
        return this.Id;
    }
}
